// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import Button, { ButtonVariants } from "@insite/mobius/Button";
import FileUpload from "@insite/mobius/FileUpload";
import { GridContainer, GridItem } from "@insite/mobius/index";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { SectionTitle } from "@rugby/App/Widgets/DesignSystem/DesignSystem";
import { generateDynamicGridItemStyle } from "@rugby/App/Widgets/DesignSystem/DesignSystem.utils";
import { dummyProductContext } from "@rugby/App/Widgets/DesignSystem/DummyData";
import ProductAddToCartButton from "@rugby/Overrides/Components/ProductAddToCartButton";
import { capitalize } from "@rugby/XDL/Utilities";
import React from "react";
import { css } from "styled-components";

const XdlAddToCart = () => {
    return (
        <>
            <GridItem {...generateDynamicGridItemStyle(2, 2)}>
                <ProductContext.Provider value={dummyProductContext}>
                    <ProductAddToCartButton data-test-selector="actionsAddToCart-545454654" />
                </ProductContext.Provider>
            </GridItem>
            <GridItem {...generateDynamicGridItemStyle(2, 2)}>
                <ProductContext.Provider value={dummyProductContext}>
                    <ProductAddToCartButton iconOnly data-test-selector="actionsAddToCart-545454654" />
                </ProductContext.Provider>
            </GridItem>
        </>
    );
};

const XdlButton = () => {
    const btnType: ButtonVariants[] = ["primary", "secondary", "tertiary"];

    const generateButton = (item: ButtonVariants) => {
        return (
            <>
                <GridItem {...generateDynamicGridItemStyle(3, 2)}>
                    <Button sizeVariant="medium" variant={item}>
                        {capitalize(item as string)}
                    </Button>
                </GridItem>
                <GridItem {...generateDynamicGridItemStyle(3, 2)}>
                    <Button disabled sizeVariant="medium" variant={item}>
                        Disabled
                    </Button>
                </GridItem>
                <GridItem {...generateDynamicGridItemStyle(3, 2)}>
                    <Button sizeVariant="small" variant={item}>
                        Small
                    </Button>
                </GridItem>
            </>
        );
    };

    return (
        <>
            {btnType.map(item => {
                return (
                    <GridContainer
                        gap={20}
                        key={uniqueId()}
                        css={css`
                            width: 100%;
                            margin-bottom: 60px;
                        `}
                    >
                        <SectionTitle title={`${item} Buttons`} />
                        {generateButton(item)}
                    </GridContainer>
                );
            })}

            <GridContainer
                gap={20}
                key={uniqueId()}
                css={css`
                    width: 100%;
                    margin-bottom: 60px;
                `}
            >
                <SectionTitle title="Add To Cart Buttons" />
                <XdlAddToCart />
            </GridContainer>

            <GridContainer
                gap={20}
                key={uniqueId()}
                css={css`
                    width: 100%;
                `}
            >
                <SectionTitle title="Upload File" />
                <GridItem {...generateDynamicGridItemStyle(1)}>
                    <StyledWrapper style={{ width: "450px" }}>
                        <FileUpload label="Default" />
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </>
    );
};

export default XdlButton;
